import PortalHeader from './PortalHeader';

export default PortalHeader;
